var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return Object.keys(_vm.notification).length
    ? _c(
        "div",
        {
          staticClass: "maintainence-banner",
          style: { "border-color": _vm.notification.color },
        },
        [
          _c("div", { staticClass: "banner-container" }, [
            _c("div", { staticClass: "content-box" }, [
              _c(
                "div",
                {
                  staticClass: "logo-box",
                  style: { background: _vm.notification.color },
                },
                [
                  _vm.notification.logo_location
                    ? _c("img", {
                        attrs: {
                          src: _vm.getBlobUrl(_vm.notification.logo_location),
                          alt: "notification-imgs",
                        },
                      })
                    : _vm._e(),
                ]
              ),
              _c("div", { staticClass: "banner-content" }, [
                _c(
                  "p",
                  {
                    staticClass: "banner-type",
                    class: [_vm.customWidth ? "wd-600" : "wd-500"],
                    style: { color: _vm.notification.color },
                  },
                  [_vm._v(" " + _vm._s(_vm.notification.header) + " ")]
                ),
                _c("p", { staticClass: "banner-time" }, [
                  _vm._v(_vm._s(_vm.customNotificationDate())),
                ]),
                _c(
                  "p",
                  {
                    staticClass: "banner-message",
                    class: [_vm.customWidth ? "wd-600" : "wd-500"],
                  },
                  [_vm._v(" " + _vm._s(_vm.notification.message) + " ")]
                ),
              ]),
              _vm.afterLogin
                ? _c("div", { staticClass: "pl-25 mt-24" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn side-btn emergo-blue-button",
                        on: { click: _vm.setBannerStatus },
                      },
                      [_vm._v("OK")]
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }